// ===========================================
// konakla - Harita tile kaynağı (TEK KAYNAK)
// ===========================================
//
// ⚠️ BU DOSYA NEDEN VAR — 2026-09-07'de yaşandı:
// CARTO, ücretsiz raster basemap'lerine "API KEY REQUIRED / carto.com/basemaps/apikey"
// filigranı basmaya başladı. Filigran TILE GÖRSELİNİN İÇİNE gömülü: istekler hâlâ
// HTTP 200 dönüyor, geçerli PNG geliyor, konsolda hata yok, CSP engellemiyor.
// Yani hiçbir otomatik kontrol yakalamadı — yalnız EKRANA BAKINCA görüldü.
// Kullanıcıya haftalarca haritanın üstünde kocaman "API KEY REQUIRED" göründü.
//
// ⭐ DERS: bir üçüncü taraf görsel servisi "çalışıyor" demek için HTTP kodu yetmez;
// gözle bak. Aynı tuzağın ikizi OpenStreetMap'te de var — `tile.openstreetmap.org`
// kullanım politikasına uymayan istemciye HTTP 200 ile "Access blocked" YAZAN BİR
// GÖRSEL döndürüyor (denendi, doğrulandı). İkisi de sessiz.
//
// ⚠️ AYRICA: bu URL ve atıf metni ÖNCEDEN İKİ DOSYADA KOPYALANMIŞTI
// (`components/common/location-map.tsx` ve `components/listings/search-results-map.tsx`).
// Bu depoda aynı desen — iki yere kopyalanan sabit — sıralama `switch`inde ÜÇ KEZ
// sessizce ayrıştı. Bu yüzden tek kaynağa alındı.

/**
 * Leaflet tile URL şablonu.
 *
 * Varsayılan CARTO Voyager'dır (sitenin bugünkü görünümü). CARTO artık ANAHTAR
 * İSTİYOR: anahtarsız istekler filigranlı tile döndürüyor.
 *
 * Anahtar `carto.com/basemaps/apikey` adresindeki formdan ÜCRETSİZ ve ANINDA
 * alınıyor (hesap açmaya bile gerek yok; e-posta + alan adı + kısa açıklama).
 * Ücretsiz kota ayda 5.000.000 tile isteği — konakla'nın bugünkü trafiğinin
 * kat kat üstünde.
 *
 * ✅ ANAHTAR ALINDI ve varsayılana KONDU (2026-09-07). Parametre adı `key`.
 * Anahtarlı @2x tile canlıda indirilip GÖZLE doğrulandı: filigran YOK.
 *
 * ⚠️ NEDEN KODA GÖMÜLÜ, .env'de DEĞİL: bu anahtar zaten HER TARAYICIYA iniyor —
 * gizli bir değer değil, alan adı beyanıyla korunuyor. Depo private. Env'de
 * tutmak da rotasyonu kolaylaştırmazdı, çünkü `NEXT_PUBLIC_*` zaten build'e
 * gömülüyor ve değişince redeploy gerekiyor. Yine de override mümkün:
 *
 *   NEXT_PUBLIC_HARITA_TILE_URL=https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?<CARTO'nun verdiği parametre>
 *
 * ⚠️ `NEXT_PUBLIC_*` değişkenleri BUILD SIRASINDA gömülür → değiştirince REDEPLOY şart.
 *
 * ⚠️ BAŞKA BİR SAĞLAYICIYA GEÇİLİRSE CSP DE GÜNCELLENMELİ:
 * `next.config.ts` içindeki `img-src` yalnız `*.basemaps.cartocdn.com` ve
 * `*.tile.openstreetmap.org` adreslerine izin veriyor. Yeni alan adı eklenmezse
 * tile'lar SESSİZCE hiç yüklenmez (konsolda CSP ihlali görünür, ekran boş kalır).
 */
const VARSAYILAN_TILE_URL =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_30md_1_1a81a9f4aed682530eafaad2";

/**
 * ⚠️ ATIF KALDIRILAMAZ. Hem OpenStreetMap'in ODbL lisansı hem CARTO'nun ücretsiz
 * kullanım şartı, atfın harita üzerinde GÖRÜNÜR kalmasını zorunlu kılıyor.
 */
const VARSAYILAN_ATIF =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';

export const HARITA_TILE_URL =
  process.env.NEXT_PUBLIC_HARITA_TILE_URL?.trim() || VARSAYILAN_TILE_URL;

export const HARITA_ATIF = process.env.NEXT_PUBLIC_HARITA_ATIF?.trim() || VARSAYILAN_ATIF;

/**
 * `{s}` yer tutucusu için alan adı harfleri. Şablonda `{s}` yoksa Leaflet bunu
 * yok sayar, zararsızdır.
 */
export const HARITA_ALT_ALANLAR = "abcd";
